import angular from 'angular';

export default function toTimeVeryShort(toTimeShortFilter) {
  'ngInject';

  return function link(date) {
    let string = toTimeShortFilter(date);
    if (string && angular.isString(string)) {
      string = string.replace(/:00/g, '');
    }

    return string;
  };
}
